var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"img-main",attrs:{"src":_vm.imgMain,"gradient":"to top right, rgba(1,1,1,.3), rgba(0,0,0,0.5)"}},[_c('Particles',{attrs:{"id":"tsparticles","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }